export type FlashcardDifficulty = "easy" | "medium" | "hard";

export function normalizeFlashcardDifficulty(value: unknown): FlashcardDifficulty {
  const v = String(value || "").trim().toLowerCase();

  if (
    v === "easy" ||
    v === "facil" ||
    v === "fácil" ||
    v === "leve" ||
    v === "baixo" ||
    v === "baixa"
  ) {
    return "easy";
  }

  if (
    v === "hard" ||
    v === "dificil" ||
    v === "difícil" ||
    v === "alto" ||
    v === "alta" ||
    v === "difficult"
  ) {
    return "hard";
  }

  return "medium";
}

export function getFlashcardDifficultyLabel(value: unknown, t?: any): string {
  const normalized = normalizeFlashcardDifficulty(value);
  if (t) {
    if (normalized === "easy") return t("flashcards.easy", "Fácil");
    if (normalized === "hard") return t("flashcards.hard", "Difícil");
    return t("flashcards.medium", "Médio");
  }

  if (normalized === "easy") return "Fácil";
  if (normalized === "hard") return "Difícil";
  return "Médio";
}

export function getFlashcardDifficultyBadgeClass(value: unknown): string {
  const normalized = normalizeFlashcardDifficulty(value);

  if (normalized === "easy") {
    return "bg-emerald-50 text-emerald-700 border-emerald-200";
  }

  if (normalized === "hard") {
    return "bg-red-50 text-red-700 border-red-200";
  }

  return "bg-amber-50 text-amber-700 border-amber-200";
}
